var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-progress-bar'),_c('v-main',[_c('AppBar',{attrs:{"handlerSidebar":_vm.handleSidebar}}),_c('SideBar',{ref:"sidebar"}),(_vm.showBreadcrumb)?_c('Breadcrumb'):_vm._e(),_c('div',{staticClass:"px-5 py-5"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }